import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CobeeSelect = ({
  styleContainer,
  disabled,
  handledChange,
  defaultValue,
  value,
  listItems,
  placeholder,
  ...rest
}) => {
  return (
    <div className="cob-input-group">
      <div className={`cob-select ${styleContainer}`}>
        <select
          className="cob-select"
          disabled={disabled}
          onChange={handledChange}
          defaultValue={defaultValue}
          value={value}
          {...rest}
        >
          <option hidden selected={value === undefined}>
            {placeholder}
          </option>
          {listItems.map((i) => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </select>
        <FontAwesomeIcon icon="chevron-down" size="xs" />
      </div>
    </div>
  );
};

CobeeSelect.defaultProps = {
  styleContainer: "",
  disabled: false,
  handledChange: () => {},
  value: "",
  placeholder: undefined,
  defaultValue: undefined,
};

CobeeSelect.propTypes = {
  styleContainer: PropTypes.string,
  disabled: PropTypes.bool,
  handledChange: PropTypes.func,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
};

export default CobeeSelect;
